import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class CommercialConditions extends BaseScenesPermissions {
    constructor({ show = true, enabled = true, commissions = {} } = {}) {
        super({ show, enabled, commissions })
    }
}

export default CommercialConditions
